import { EMPTY_STRING } from '../../../../../common/constants/grimsby';
import { getGoalsFromCustomers } from '../../FormSections/EditBaseDetailsFormSection/Sections/OrganizationGoalsSelect';
import { Customer, LearningGoal } from '../../../../interfaces/activity';

// activity.customers at runtime carries the backend-enriched field
type CustomerWithGoals = Pick<Customer, 'organization_id'> & {
    organization_learning_goals?: LearningGoal[] | null;
};

interface OrganizationGoalsDisplayProps {
    customers: Array<CustomerWithGoals> | null | undefined;
    selectedGoalIds: string[] | null | undefined;
}

/**
 * Read-only display of associated learning goals for the activity detail page.
 * Goals are injected by the backend in the get_activity response.
 */
const OrganizationGoalsDisplay = ({
    customers,
    selectedGoalIds,
}: OrganizationGoalsDisplayProps) => {
    if (!selectedGoalIds?.length) {
        return <>{EMPTY_STRING}</>;
    }

    const goals = getGoalsFromCustomers(customers);
    const goalLookup = new Map(goals.map((g) => [g.id, g.name]));

    // Map selected IDs to display names; fall back to the raw ID if a goal
    // was deleted from the org after it was saved on the activity.
    const names = selectedGoalIds.map((id) => goalLookup.get(id) ?? id);

    return <>{names.join(', ')}</>;
};

export default OrganizationGoalsDisplay;
